import AppealCard from './component'

export default AppealCard
